import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useAppContext } from "../utils/context/app-context";
import {
	ContentContainer,
	TitleHeader,
	TableLoading,
	AlertMessage,
	NarrowContentWrapper,
} from "../components/UiComponents";
import {
	CourseHeader,
	CourseWrapper,
} from "../components/CourseComponents";
import useDocumentTitle from "../components/useDocumentTitle";

const EvaluationFormPage = () => {
	const { api } = useAppContext();
	useDocumentTitle("Evaluation Form");
	const { formId } = useParams();
	const [loading, setLoading] = useState(true);
	const [formHtml, setFormHtml] = useState(null);
	const [error, setError] = useState(null);

	useEffect(() => {
		fetchForm();
	}, []);

	async function fetchForm() {
		setLoading(true);
		const { data, error } = await api.fetchData(`/evaluation-forms/${formId}`);

		if (data?.html) {
			setFormHtml(data.html);
			setLoading(false);
		} else {
			setError(error || data?.error || "An error occurred while loading the evaluation form.");
			setLoading(false);
		}
	}

	return (
		<div className="evaluation-form-page">
			<CourseHeader />
			<ContentContainer classes="mb-4">
				<CourseWrapper>
					<TitleHeader title={`Evaluation Form`} />
					<div className="evaluation-form">
						<NarrowContentWrapper>
							{loading ? (
								<TableLoading rows={5} />
							) : (
								<>
									{error ? (
										<AlertMessage type="danger" message={error} />
									) : (
										<div 
											className="evaluation-form-wrapper"
											dangerouslySetInnerHTML={{ __html: formHtml }}
										/>
									)}
								</>
							)}
						</NarrowContentWrapper>
					</div>
				</CourseWrapper>
			</ContentContainer>
		</div>
	);
};

export default EvaluationFormPage;
